export const API = {
  PORT:
    process.env.NODE_ENV == "development"
      ? process.env.REACT_APP_API_BASE_URL_LOCAL
      : process.env.REACT_APP_API_BASE_URL_STAGE,
};

export const BASEURL = {
  PORT:
    process.env.NODE_ENV == "development"
      ? process.env.REACT_APP_API_BASE_URL_LOCAL
      : process.env.REACT_APP_API_BASE_URL_STAGE,
};

export const FRONTENDURL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_API_BASE_URL_LOCAL
    : process.env.REACT_APP_API_BASE_URL_STAGE;
